/**
 * DeliveryStatus
 * @author ftgibran
 */

export enum DeliveryStatus {
  PENDING = 1,
  STARTED = 2,
  FINISHED = 3,
}
